if (typeof DynaBase_ContextMenu == 'undefined')
{
    var DynaBase_ContextMenu =
    {
        parts: [],

        /**
         * Prida tlacitko do kontextoveho menu
         *
         * @param {string} label
         * @param {string} icon
         * @param {function} callback
         */
        addButton: function(label, icon, callback)
        {
            var index = this.parts.length;

            this.parts[index] = {};
            this.parts[index].type = 'button';
            this.parts[index].label = label;
            this.parts[index].icon = icon;
            this.parts[index].callback = callback;
        },

        addDivider: function()
        {
            var index = this.parts.length;

            this.parts[index] = {};
            this.parts[index].type = 'divider';
        },

        addHeader: function(label)
        {
            var index = this.parts.length;

            this.parts[index] = {};
            this.parts[index].type = 'header';
            this.parts[index].label = label;
        },

        /**
         * Zobrazi kontextove menu
         *
         * @param e
         * @param element
         */
        build: function(e, element)
        {
            this.remove();

            var elementContainer = $('<div id="contextmenu" class="dropdown-menu" role="menu"></div>');

            if (typeof this.parts != 'undefined') {
                $.each(this.parts, function(i, part) {

                    var elementItem = '';

                    if ('divider' == part.type) {
                        elementItem = $('<div class="dropdown-divider"></div>');
                        elementContainer.append(elementItem);
                        return true;
                    }

                    if ('header' == part.type) {
                        elementItem = $('<h6 class="dropdown-header">' + part.label + '</h6>');
                        elementContainer.append(elementItem);
                        return true;
                    }

                    var icon = '';
                    if (typeof part.icon != 'undefined' && part.icon != '') {
                        icon = '<i class="fas fa-fw fa-' + part.icon + '"></i> ';
                    }

                    elementItem = $('<a class="dropdown-item" href="#" tabindex="-1">' + icon + part.label + '</a>');

                    elementItem.on('click.dynabase.contextmenu', function (e) {
                        e.preventDefault();
                        if ($.isFunction(part.callback)) {
                            part.callback.apply();
                            DynaBase_ContextMenu.remove();
                        }
                        return false;
                    });

                    elementContainer.append(elementItem);
                });
            }

            $('body').append(elementContainer);

            var windowWidth = $(window).outerWidth();
            var windowHeight = $(window).outerHeight();
            var windowScrollTop = $(window).scrollTop();
            var elementOffset = $(element).offset();
            var elementHeight = $(element).outerHeight();
            var top = e.pageY;
            var left = e.pageX;
            var contextMenu = $('#contextmenu');

            // Left is minimal
            if (0 > (left + contextMenu.outerWidth())) {
                left = 10;
            }

            // Prava je maximalni
            if (left > (windowWidth - contextMenu.outerWidth())) {
                left = windowWidth - contextMenu.outerWidth() - 10;
            }

            // Spodni je vyssi nez okno
            if ((elementOffset.top + elementHeight) > (windowHeight + windowScrollTop)) {
                top = elementOffset.top - contextMenu.outerHeight() - 10;
            }

            // Pridame contextmenu do radku
            // Zobrazime contextove menu
            contextMenu
                .css('top', top + 'px')
                .css('left', left + 'px')
                .stop()
                .show();

            // Skryti v pripade kliknuti mimo contextmenu
            $(document).on('mousedown.dynabase.contextmenu', function(e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (code == 1 && contextMenu.length) {
                    if (e.target.id != 'contextmenu' && !$(e.target).parents('#contextmenu').length) {
                        e.preventDefault();
                        DynaBase_ContextMenu.remove();
                    }
                }
            });

            // Skryti menu v pripade stisku ESC
            $(document).on("keydown.dynabase.contextmenu", function(e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (code == 27 && contextMenu.length) {
                    e.preventDefault();
                    DynaBase_ContextMenu.remove();
                }
            });

            this.parts = [];
        },

        /**
         * Odstrani kontextove menu
         */
        remove: function()
        {
            $(document).off('.dynabase.contextmenu');
            $('#contextmenu').remove();
        }
    }
}
